export * from './productDetailsModal';
